/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-return-bill.reducer';

export const PharmacyReturnBillDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyReturnBillEntity = useAppSelector(state => state.pharmacyReturnBill.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyReturnBillDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.detail.title">PharmacyReturnBill</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.id}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.billNumber}</dd>
          <dt>
            <span id="billDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.billDate">Bill Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.billDate}</dd>
          <dt>
            <span id="claimAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.claimAmount">Claim Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.claimAmount}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.totalCost}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.lastUpdated}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.sgst}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.status">Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.status}</dd>
          <dt>
            <span id="printed">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.printed">Printed</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.printed ? 'true' : 'false'}</dd>
          <dt>
            <span id="printCount">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.printCount">Print Count</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillEntity.printCount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyReturnBillEntity.pharmacy ? pharmacyReturnBillEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyReturnBillEntity.supplier ? pharmacyReturnBillEntity.supplier.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.processedBy">Processed By</Translate>
          </dt>
          <dd>{pharmacyReturnBillEntity.processedBy ? pharmacyReturnBillEntity.processedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-return-bill" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-return-bill/${pharmacyReturnBillEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyReturnBillDetail;
